export default __webpack_public_path__ + "static/media/quiz.58538ea7.svg";